<template>
  <form
    autocomplete="off"
    class="a-form-column m-tinymce-primary"
    name="create-notice-form"
    @submit.prevent="createContenidoEntregable"
  >
    <AtomSelectPrimary
      v-model.number="entrega"
      :elements="tiposDeEntrega"
      :inputError="$v.entrega.$error"
      keyField="id"
      :label="$t('mEditionAssetSendingOfDeliverablesCreate.inputs.entrega.label')"
      :messageError="messageErrorEntrega"
      name="entrega"
      textField="nombre"
      @blur="$v.entrega.$touch()"
    />

    <transition name="a-transtion-slide">
      <AtomInputPrimary
        v-model="entregable.entregable.dia"
        v-show="entrega == 1"
        :inputError="$v.entregable.entregable.dia.$error"
        :label="$t('mEditionAssetSendingOfDeliverablesCreate.inputs.dia.label')"
        message=""
        :messageError="messageErrorDia"
        min="0"
        name="dia"
        type="number"
        @blur="$v.entregable.entregable.dia.$touch()"
      />
    </transition>

    <AtomInputPrimary
      v-model="entregable.entregable.asunto"
      :inputError="$v.entregable.entregable.asunto.$error"
      :label="$t('mEditionAssetSendingOfDeliverablesCreate.inputs.asunto.label')"
      :message="$t('mEditionAssetSendingOfDeliverablesCreate.inputs.asunto.message')"
      :messageError="messageErrorAsunto"
      name="asunto"
      type="text"
      @blur="$v.entregable.entregable.asunto.$touch()"
    />

    <AtomTinymcePrimary
      v-model="entregable.entregable.mensaje"
      :inputError="$v.entregable.entregable.mensaje.$error"
      :label="$t('mEditionAssetSendingOfDeliverablesCreate.inputs.mensaje.label')"
      :messageError="messageErrorMensaje"
      name="mensaje"
      @onBlur="$v.entregable.entregable.mensaje.$touch()"
    />

    <AtomButtonPrimary :button-primary="buttonPrimary"/>
    <AtomButtonSecondary
      v-if="false"
      :button-secondary="buttonSecondary.reset"
    />
  </form>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAssetSendingOfDeliverablesCreate',

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAssetSendingOfDeliverablesCreate.buttonPrimary'),
        class: 'margin-right-medium margin-top-large',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-reset-secondary',
          component: '',
          icon: '',
          method: '',
          text: this.$t('aButtonSecondary.actions.reset'),
          type: 'reset'
        }
      },

      entrega: '',

      entregable: {
        academia: '',

        entregable: {
          asunto: '',
          dia: 0,
          mensaje: ''
        }
      },

      tiposDeEntrega: [
        {
          id: 0,
          nombre: 'Inmediato'
        },

        {
          id: 1,
          nombre: 'Personalizar día'
        }
      ]
    }
  },

  validations: {
    entrega: {
      required
    },

    entregable: {
      entregable: {
        asunto: {
          maxLength: maxLength(255),
          minLength: minLength(5),
          required
        },

        dia: {
          minLength: minLength(0),
          required
        },

        mensaje: {
          required
        }
      }
    }
  },

  computed: {
    messageErrorAsunto () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesCreate', this.$v.entregable.entregable.asunto, 'asunto')
    },

    messageErrorDia () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesCreate', this.$v.entregable.entregable.dia, 'dia')
    },

    messageErrorEntrega () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesCreate', this.$v.entrega, 'entrega')
    },

    messageErrorMensaje () {
      return this.$validation.getValidationMessage('mEditionAssetSendingOfDeliverablesCreate', this.$v.entregable.entregable.mensaje, 'mensaje')
    }
  },

  watch: {
    entrega () {
      this.entregable.entregable.dia = this.entrega === 0 ? 0 : 1
    }
  },

  created () {
    this.entregable.academia = this.$store.getters.getAcademyData.id
  },

  methods: {
    createContenidoEntregable () {
      this.$v.$touch()
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.create('contenido', 'createContenidoEntregable', this.entregable, [this.$route.params.subid])
          .then(response => {
            this.$modal.updateData()
            this.$alerts.pushAlert('mEditionAssetSendingOfDeliverablesCreate', 'createContenidoEntregable', 'success')
            this.buttonPrimary.sending = false
            this.$router.push(`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.activation.subject')}/${this.$t('mEditionMenu.asset.activation.children.sendingOfDeliverables.subedition')}`)
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetSendingOfDeliverablesCreate', 'createContenidoEntregable', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
